var _rect, _path, _path2, _mask, _rect2, _rect3, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColetaIconActiveBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 119,
    rx: 59.5,
    fill: "#FFF5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3527 64.5181L48.9866 60.5745L47.8204 58.6309L46.6542 60.5745L44.288 64.5181L43.9892 65.1532C42.6676 67.9615 44.7166 71.1903 47.8204 71.1903C50.9241 71.1903 52.9732 67.9615 51.6516 65.1532L51.3527 64.5181ZM47.8204 62.5182L46.0548 65.4608L45.7988 66.0048C45.1015 67.4866 46.1827 69.1903 47.8204 69.1903C49.4581 69.1903 50.5393 67.4866 49.842 66.0048L49.586 65.4608L47.8204 62.5182Z",
    fill: "#D91F05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5117 32.25H64.1902C64.6044 32.25 64.9402 32.5858 64.9402 33V79.9879H29.7617V33C29.7617 32.5858 30.0975 32.25 30.5117 32.25Z",
    stroke: "#D91F05",
    strokeWidth: 2.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_2661_2846",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.792,
    y: 38.5371,
    width: 25.119,
    height: 12.5595,
    rx: 1.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.792,
    y: 38.5371,
    width: 25.119,
    height: 12.5595,
    rx: 1.5,
    stroke: "#D91F05",
    strokeWidth: 5,
    mask: "url(#path-4-inside-1_2661_2846)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.25,
    y: 79.9766,
    width: 40.2022,
    height: 7.54759,
    rx: 3.77379,
    stroke: "#D91F05",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3155 57.8603V59.892H76.9822C76.568 59.892 76.2322 59.5562 76.2322 59.142L76.2322 47.7432L78.8463 44.2577L91.3155 57.8603Z",
    stroke: "#D91F05",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4829 68.6784H72.982C74.0866 68.6784 74.982 69.5738 74.982 70.6784V80.0057C74.982 82.7671 77.2206 85.0057 79.982 85.0057H83.7736H86.3093C89.0708 85.0057 91.3093 82.7671 91.3093 80.0057V59.8867",
    stroke: "#D91F05",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1496 47.4228L69.0068 42.2659C68.0617 41.5836 67.8487 40.2643 68.531 39.3192C69.2133 38.3741 70.5326 38.1611 71.4777 38.8434L78.6206 44.0003L76.1496 47.4228Z",
    stroke: "#D91F05",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColetaIconActiveBackground);
export default __webpack_public_path__ + "static/media/coletaIconActiveBackground.52289030729328ebad32c773d5091315.svg";
export { ForwardRef as ReactComponent };